import { createFileRoute } from '@tanstack/react-router'
import ImagePage from 'pages/app/image-page/ImagePage'

export const Route = createFileRoute('/image/')({
  component: ImagePage,
})
